import React, { useState, useEffect } from 'react';
import NextImage from 'next/image';

import type { Option, Props as SelectProps } from 'Elements/Input/Select';
import VisuallyHidden from 'Elements/VisuallyHidden';
import Label from 'Elements/Label';
import { ArrowLinkButtonProps } from 'Elements/Button/Arrow';
import Hidden from 'Elements/Hidden';

import VariantSelect from './subcomponents/VariantSelect';

import applicationWavePNG from 'Public/graphics/waves/course-apply/application.png';
import applicationWaveMobilePNG from 'Public/graphics/waves/course-apply/application-mobile.png';
import openDayWavePNG from 'Public/graphics/waves/course-apply/open-day.png';
import openDayWaveMobilePNG from 'Public/graphics/waves/course-apply/open-day-mobile.png';

import {
    Container,
    ApplyContainer,
    InputContainer,
    ApplyButton,
    OpenDayContainer,
    Heading,
    OpenDayButton,
    WaveWrapper,
    WaveApplication,
    WaveOpenDay
} from './CourseApply.styled';

interface LinkOption extends Option {
    link: ArrowLinkButtonProps;
}
interface SelectWithLinkOption extends SelectProps {
    options: LinkOption[];
}

export interface Props {
    select: SelectWithLinkOption;
    apply: {
        heading: string;
    };
    openDay: {
        heading: string;
        link: ArrowLinkButtonProps;
    };
}

const CourseApply: React.FC<Props> = props => {
    const { apply, openDay, select } = props;
    const [value, setValue] = useState<string | null>();
    const [links, setLinks] = useState<Record<string, ArrowLinkButtonProps> | null>(null);

    useEffect(() => {
        const links = {};

        select.options.forEach(option => (links[option.value] = option.link));

        setLinks(links);
    }, [select]);

    return (
        <Container>
            <ApplyContainer>
                <WaveWrapper>
                    <WaveApplication>
                        <Hidden defaultHidden={false} large={true}>
                            <NextImage
                                src={applicationWaveMobilePNG}
                                alt=""
                                fill
                                style={{ objectFit: 'cover' }}
                            />
                        </Hidden>
                        <Hidden large={false}>
                            <NextImage
                                src={applicationWavePNG}
                                alt=""
                                fill
                                style={{ objectFit: 'cover', objectPosition: 'right center' }}
                            />
                        </Hidden>
                    </WaveApplication>
                </WaveWrapper>
                <Heading>{apply.heading}</Heading>
                <InputContainer>
                    <VisuallyHidden>
                        <Label id="variant-label" htmlFor="course-apply">
                            Choose course variant
                        </Label>
                    </VisuallyHidden>
                    <VariantSelect
                        {...select}
                        handleValueChange={value => setValue(value)}
                        aria-labelledby="variant-label"
                    />
                    {links && value && <ApplyButton {...links[value]} id="application-apply" />}
                </InputContainer>
            </ApplyContainer>
            <OpenDayContainer>
                <WaveWrapper>
                    <WaveOpenDay>
                        {/* TODO Needs different wave */}

                        <Hidden defaultHidden={false} large={true}>
                            <NextImage
                                src={openDayWaveMobilePNG}
                                alt=""
                                fill
                                style={{ objectFit: 'cover' }}
                            />
                        </Hidden>
                        <Hidden large={false}>
                            <NextImage
                                src={openDayWavePNG}
                                alt=""
                                fill
                                style={{ objectFit: 'cover', objectPosition: 'left center' }}
                            />
                        </Hidden>
                    </WaveOpenDay>
                </WaveWrapper>
                <Heading>{openDay.heading}</Heading>
                <OpenDayButton {...openDay.link} variant="secondary" />
            </OpenDayContainer>
        </Container>
    );
};

export default CourseApply;
